import { gql } from "lib/apolloClient";

export const learningCourseItemFragment = gql`
  fragment learningCourseItem on LearningCourse {
    id
    title
    type
    grades {
      id
      name
    }
    primaryGrade {
      id
    }
    subjects {
      id
      name
    }
    academicYears {
      id
      startDate
      endDate
    }
  }
`;
